var map = {
	"./LBBox.png": 112,
	"./LTBox.png": 113,
	"./WechatIMG5.png": 159,
	"./car.jpg": 605,
	"./carousel_1.jpg": 162,
	"./carousel_2.jpg": 163,
	"./carousel_3.jpg": 64,
	"./carousel_4.jpg": 164,
	"./china.jpg": 114,
	"./competitionBG.png": 103,
	"./courseB.png": 115,
	"./courseG.png": 116,
	"./currBanner.jpg": 117,
	"./documentDataB.png": 118,
	"./documentDataG.png": 119,
	"./empty.jpg": 120,
	"./gradingTestB.png": 121,
	"./gradingTestG.png": 122,
	"./head_tit_1.png": 123,
	"./head_tit_2.png": 124,
	"./head_tit_3.png": 125,
	"./header_pic.png": 606,
	"./header_pic2.png": 158,
	"./hoist.jpg": 607,
	"./imgS/amusement.jpg": 608,
	"./imgS/cockroach.jpg": 609,
	"./imgS/combat.jpg": 610,
	"./imgS/crocodile.jpg": 611,
	"./imgS/dinosaur.jpg": 612,
	"./imgS/dodgem.jpg": 613,
	"./imgS/frog.jpg": 614,
	"./imgS/game.jpg": 615,
	"./imgS/insect.jpg": 616,
	"./imgS/patrol.jpg": 617,
	"./imgS/plane.jpg": 618,
	"./imgT/aston.jpg": 619,
	"./imgT/basket.jpg": 620,
	"./imgT/bird.jpg": 621,
	"./imgT/birdT4.jpg": 622,
	"./imgT/boxing.jpg": 623,
	"./imgT/bulldozer.jpg": 624,
	"./imgT/carT5.jpg": 625,
	"./imgT/carry.jpg": 626,
	"./imgT/cat.jpg": 627,
	"./imgT/caterpillar.jpg": 628,
	"./imgT/claw.jpg": 629,
	"./imgT/dinosaurT1.jpg": 630,
	"./imgT/dog.jpg": 631,
	"./imgT/fans.jpg": 632,
	"./imgT/filter.jpg": 633,
	"./imgT/followthesun.jpg": 634,
	"./imgT/forklift.jpg": 635,
	"./imgT/fulande.jpg": 636,
	"./imgT/gatling.jpg": 637,
	"./imgT/geliya.jpg": 638,
	"./imgT/logistics.jpg": 639,
	"./imgT/mine.jpg": 640,
	"./imgT/motor.jpg": 641,
	"./imgT/patrolCar.jpg": 642,
	"./imgT/racing.jpg": 643,
	"./imgT/radar.jpg": 644,
	"./imgT/tank.jpg": 645,
	"./imgT/thor.jpg": 646,
	"./imgT/wallE.jpg": 647,
	"./imgT/weighing.jpg": 648,
	"./intro.jpg": 126,
	"./item_bgp.png": 127,
	"./item_bgp2.png": 128,
	"./item_bgp3.png": 129,
	"./lamp.jpg": 649,
	"./levelS/amusement/amusement(1).PNG": 89,
	"./levelS/amusement/amusement(10).PNG": 169,
	"./levelS/amusement/amusement(11).PNG": 170,
	"./levelS/amusement/amusement(12).PNG": 171,
	"./levelS/amusement/amusement(13).PNG": 172,
	"./levelS/amusement/amusement(14).PNG": 173,
	"./levelS/amusement/amusement(15).PNG": 174,
	"./levelS/amusement/amusement(16).PNG": 175,
	"./levelS/amusement/amusement(17).PNG": 176,
	"./levelS/amusement/amusement(18).PNG": 177,
	"./levelS/amusement/amusement(19).PNG": 178,
	"./levelS/amusement/amusement(2).PNG": 179,
	"./levelS/amusement/amusement(20).PNG": 180,
	"./levelS/amusement/amusement(21).PNG": 181,
	"./levelS/amusement/amusement(22).PNG": 182,
	"./levelS/amusement/amusement(23).PNG": 183,
	"./levelS/amusement/amusement(24).PNG": 184,
	"./levelS/amusement/amusement(25).PNG": 185,
	"./levelS/amusement/amusement(26).PNG": 186,
	"./levelS/amusement/amusement(27).PNG": 187,
	"./levelS/amusement/amusement(3).PNG": 188,
	"./levelS/amusement/amusement(4).PNG": 189,
	"./levelS/amusement/amusement(5).PNG": 190,
	"./levelS/amusement/amusement(6).PNG": 191,
	"./levelS/amusement/amusement(7).PNG": 192,
	"./levelS/amusement/amusement(8).PNG": 193,
	"./levelS/amusement/amusement(9).PNG": 194,
	"./levelS/cockroach/cockroach(1).PNG": 90,
	"./levelS/cockroach/cockroach(10).PNG": 195,
	"./levelS/cockroach/cockroach(11).PNG": 196,
	"./levelS/cockroach/cockroach(12).PNG": 197,
	"./levelS/cockroach/cockroach(13).PNG": 198,
	"./levelS/cockroach/cockroach(14).PNG": 199,
	"./levelS/cockroach/cockroach(15).PNG": 200,
	"./levelS/cockroach/cockroach(16).PNG": 201,
	"./levelS/cockroach/cockroach(17).PNG": 202,
	"./levelS/cockroach/cockroach(18).PNG": 203,
	"./levelS/cockroach/cockroach(19).PNG": 204,
	"./levelS/cockroach/cockroach(2).PNG": 205,
	"./levelS/cockroach/cockroach(20).PNG": 206,
	"./levelS/cockroach/cockroach(21).PNG": 207,
	"./levelS/cockroach/cockroach(22).PNG": 208,
	"./levelS/cockroach/cockroach(23).PNG": 209,
	"./levelS/cockroach/cockroach(24).PNG": 210,
	"./levelS/cockroach/cockroach(25).PNG": 211,
	"./levelS/cockroach/cockroach(26).PNG": 212,
	"./levelS/cockroach/cockroach(27).PNG": 213,
	"./levelS/cockroach/cockroach(28).PNG": 214,
	"./levelS/cockroach/cockroach(3).PNG": 215,
	"./levelS/cockroach/cockroach(4).PNG": 216,
	"./levelS/cockroach/cockroach(5).PNG": 217,
	"./levelS/cockroach/cockroach(6).PNG": 218,
	"./levelS/cockroach/cockroach(7).PNG": 219,
	"./levelS/cockroach/cockroach(8).PNG": 220,
	"./levelS/cockroach/cockroach(9).PNG": 221,
	"./levelS/combat/combat(1).PNG": 91,
	"./levelS/combat/combat(10).PNG": 222,
	"./levelS/combat/combat(11).PNG": 223,
	"./levelS/combat/combat(12).PNG": 224,
	"./levelS/combat/combat(13).PNG": 225,
	"./levelS/combat/combat(14).PNG": 226,
	"./levelS/combat/combat(15).PNG": 227,
	"./levelS/combat/combat(16).PNG": 228,
	"./levelS/combat/combat(17).PNG": 229,
	"./levelS/combat/combat(18).PNG": 230,
	"./levelS/combat/combat(19).PNG": 231,
	"./levelS/combat/combat(2).PNG": 232,
	"./levelS/combat/combat(20).PNG": 233,
	"./levelS/combat/combat(21).PNG": 234,
	"./levelS/combat/combat(22).PNG": 235,
	"./levelS/combat/combat(23).PNG": 236,
	"./levelS/combat/combat(24).PNG": 237,
	"./levelS/combat/combat(25).PNG": 238,
	"./levelS/combat/combat(26).PNG": 239,
	"./levelS/combat/combat(27).PNG": 240,
	"./levelS/combat/combat(28).PNG": 241,
	"./levelS/combat/combat(3).PNG": 242,
	"./levelS/combat/combat(4).PNG": 243,
	"./levelS/combat/combat(5).PNG": 244,
	"./levelS/combat/combat(6).PNG": 245,
	"./levelS/combat/combat(7).PNG": 246,
	"./levelS/combat/combat(8).PNG": 247,
	"./levelS/combat/combat(9).PNG": 248,
	"./levelS/crocodile/crocodile(1).PNG": 92,
	"./levelS/crocodile/crocodile(10).PNG": 249,
	"./levelS/crocodile/crocodile(11).PNG": 250,
	"./levelS/crocodile/crocodile(12).PNG": 251,
	"./levelS/crocodile/crocodile(13).PNG": 252,
	"./levelS/crocodile/crocodile(14).PNG": 253,
	"./levelS/crocodile/crocodile(15).PNG": 254,
	"./levelS/crocodile/crocodile(16).PNG": 255,
	"./levelS/crocodile/crocodile(17).PNG": 256,
	"./levelS/crocodile/crocodile(18).PNG": 257,
	"./levelS/crocodile/crocodile(19).PNG": 258,
	"./levelS/crocodile/crocodile(2).PNG": 259,
	"./levelS/crocodile/crocodile(20).PNG": 260,
	"./levelS/crocodile/crocodile(21).PNG": 261,
	"./levelS/crocodile/crocodile(22).PNG": 262,
	"./levelS/crocodile/crocodile(23).PNG": 263,
	"./levelS/crocodile/crocodile(24).PNG": 264,
	"./levelS/crocodile/crocodile(25).PNG": 265,
	"./levelS/crocodile/crocodile(26).PNG": 266,
	"./levelS/crocodile/crocodile(27).PNG": 267,
	"./levelS/crocodile/crocodile(28).PNG": 268,
	"./levelS/crocodile/crocodile(29).PNG": 269,
	"./levelS/crocodile/crocodile(3).PNG": 270,
	"./levelS/crocodile/crocodile(30).PNG": 271,
	"./levelS/crocodile/crocodile(31).PNG": 272,
	"./levelS/crocodile/crocodile(32).PNG": 273,
	"./levelS/crocodile/crocodile(33).PNG": 274,
	"./levelS/crocodile/crocodile(4).PNG": 275,
	"./levelS/crocodile/crocodile(5).PNG": 276,
	"./levelS/crocodile/crocodile(6).PNG": 277,
	"./levelS/crocodile/crocodile(7).PNG": 278,
	"./levelS/crocodile/crocodile(8).PNG": 279,
	"./levelS/crocodile/crocodile(9).PNG": 280,
	"./levelS/dinosaur/dinosaur(1).PNG": 93,
	"./levelS/dinosaur/dinosaur(10).PNG": 281,
	"./levelS/dinosaur/dinosaur(11).PNG": 282,
	"./levelS/dinosaur/dinosaur(12).PNG": 283,
	"./levelS/dinosaur/dinosaur(13).PNG": 284,
	"./levelS/dinosaur/dinosaur(14).PNG": 285,
	"./levelS/dinosaur/dinosaur(15).PNG": 286,
	"./levelS/dinosaur/dinosaur(16).PNG": 287,
	"./levelS/dinosaur/dinosaur(17).PNG": 288,
	"./levelS/dinosaur/dinosaur(18).PNG": 289,
	"./levelS/dinosaur/dinosaur(19).PNG": 290,
	"./levelS/dinosaur/dinosaur(2).PNG": 291,
	"./levelS/dinosaur/dinosaur(20).PNG": 292,
	"./levelS/dinosaur/dinosaur(21).PNG": 293,
	"./levelS/dinosaur/dinosaur(22).PNG": 294,
	"./levelS/dinosaur/dinosaur(23).PNG": 295,
	"./levelS/dinosaur/dinosaur(24).PNG": 296,
	"./levelS/dinosaur/dinosaur(25).PNG": 297,
	"./levelS/dinosaur/dinosaur(26).PNG": 298,
	"./levelS/dinosaur/dinosaur(3).PNG": 299,
	"./levelS/dinosaur/dinosaur(4).PNG": 300,
	"./levelS/dinosaur/dinosaur(5).PNG": 301,
	"./levelS/dinosaur/dinosaur(6).PNG": 302,
	"./levelS/dinosaur/dinosaur(7).PNG": 303,
	"./levelS/dinosaur/dinosaur(8).PNG": 304,
	"./levelS/dinosaur/dinosaur(9).PNG": 305,
	"./levelS/dodgem/dodgem(1).PNG": 94,
	"./levelS/dodgem/dodgem(10).PNG": 306,
	"./levelS/dodgem/dodgem(11).PNG": 307,
	"./levelS/dodgem/dodgem(12).PNG": 308,
	"./levelS/dodgem/dodgem(13).PNG": 309,
	"./levelS/dodgem/dodgem(14).PNG": 310,
	"./levelS/dodgem/dodgem(15).PNG": 311,
	"./levelS/dodgem/dodgem(16).PNG": 312,
	"./levelS/dodgem/dodgem(17).PNG": 313,
	"./levelS/dodgem/dodgem(18).PNG": 314,
	"./levelS/dodgem/dodgem(19).PNG": 315,
	"./levelS/dodgem/dodgem(2).PNG": 316,
	"./levelS/dodgem/dodgem(20).PNG": 317,
	"./levelS/dodgem/dodgem(21).PNG": 318,
	"./levelS/dodgem/dodgem(22).PNG": 319,
	"./levelS/dodgem/dodgem(23).PNG": 320,
	"./levelS/dodgem/dodgem(24).PNG": 321,
	"./levelS/dodgem/dodgem(25).PNG": 322,
	"./levelS/dodgem/dodgem(26).PNG": 323,
	"./levelS/dodgem/dodgem(27).PNG": 324,
	"./levelS/dodgem/dodgem(28).PNG": 325,
	"./levelS/dodgem/dodgem(29).PNG": 326,
	"./levelS/dodgem/dodgem(3).PNG": 327,
	"./levelS/dodgem/dodgem(4).PNG": 328,
	"./levelS/dodgem/dodgem(5).PNG": 329,
	"./levelS/dodgem/dodgem(6).PNG": 330,
	"./levelS/dodgem/dodgem(7).PNG": 331,
	"./levelS/dodgem/dodgem(8).PNG": 332,
	"./levelS/dodgem/dodgem(9).PNG": 333,
	"./levelS/frog/frog(1).PNG": 95,
	"./levelS/frog/frog(10).PNG": 334,
	"./levelS/frog/frog(11).PNG": 335,
	"./levelS/frog/frog(12).PNG": 336,
	"./levelS/frog/frog(13).PNG": 337,
	"./levelS/frog/frog(14).PNG": 338,
	"./levelS/frog/frog(15).PNG": 339,
	"./levelS/frog/frog(16).PNG": 340,
	"./levelS/frog/frog(17).PNG": 341,
	"./levelS/frog/frog(18).PNG": 342,
	"./levelS/frog/frog(19).PNG": 343,
	"./levelS/frog/frog(2).PNG": 344,
	"./levelS/frog/frog(20).PNG": 345,
	"./levelS/frog/frog(21).PNG": 346,
	"./levelS/frog/frog(22).PNG": 347,
	"./levelS/frog/frog(23).PNG": 348,
	"./levelS/frog/frog(24).PNG": 349,
	"./levelS/frog/frog(25).PNG": 350,
	"./levelS/frog/frog(26).PNG": 351,
	"./levelS/frog/frog(27).PNG": 352,
	"./levelS/frog/frog(28).PNG": 353,
	"./levelS/frog/frog(29).PNG": 354,
	"./levelS/frog/frog(3).PNG": 355,
	"./levelS/frog/frog(4).PNG": 356,
	"./levelS/frog/frog(5).PNG": 357,
	"./levelS/frog/frog(6).PNG": 358,
	"./levelS/frog/frog(7).PNG": 359,
	"./levelS/frog/frog(8).PNG": 360,
	"./levelS/frog/frog(9).PNG": 361,
	"./levelS/game/game(1).PNG": 96,
	"./levelS/game/game(10).PNG": 362,
	"./levelS/game/game(11).PNG": 363,
	"./levelS/game/game(12).PNG": 364,
	"./levelS/game/game(13).PNG": 365,
	"./levelS/game/game(14).PNG": 366,
	"./levelS/game/game(15).PNG": 367,
	"./levelS/game/game(16).PNG": 368,
	"./levelS/game/game(17).PNG": 369,
	"./levelS/game/game(18).PNG": 370,
	"./levelS/game/game(19).PNG": 371,
	"./levelS/game/game(2).PNG": 372,
	"./levelS/game/game(20).PNG": 373,
	"./levelS/game/game(21).PNG": 374,
	"./levelS/game/game(22).PNG": 375,
	"./levelS/game/game(23).PNG": 376,
	"./levelS/game/game(24).PNG": 377,
	"./levelS/game/game(25).PNG": 378,
	"./levelS/game/game(26).PNG": 379,
	"./levelS/game/game(27).PNG": 380,
	"./levelS/game/game(28).PNG": 381,
	"./levelS/game/game(29).PNG": 382,
	"./levelS/game/game(3).PNG": 383,
	"./levelS/game/game(30).PNG": 384,
	"./levelS/game/game(31).PNG": 385,
	"./levelS/game/game(4).PNG": 386,
	"./levelS/game/game(5).PNG": 387,
	"./levelS/game/game(6).PNG": 388,
	"./levelS/game/game(7).PNG": 389,
	"./levelS/game/game(8).PNG": 390,
	"./levelS/game/game(9).PNG": 391,
	"./levelS/insect/insect(1).PNG": 62,
	"./levelS/insect/insect(10).PNG": 392,
	"./levelS/insect/insect(11).PNG": 393,
	"./levelS/insect/insect(12).PNG": 394,
	"./levelS/insect/insect(13).PNG": 395,
	"./levelS/insect/insect(14).PNG": 396,
	"./levelS/insect/insect(15).PNG": 397,
	"./levelS/insect/insect(16).PNG": 398,
	"./levelS/insect/insect(17).PNG": 399,
	"./levelS/insect/insect(18).PNG": 400,
	"./levelS/insect/insect(19).PNG": 401,
	"./levelS/insect/insect(2).PNG": 402,
	"./levelS/insect/insect(20).PNG": 403,
	"./levelS/insect/insect(21).PNG": 404,
	"./levelS/insect/insect(22).PNG": 405,
	"./levelS/insect/insect(23).PNG": 406,
	"./levelS/insect/insect(24).PNG": 407,
	"./levelS/insect/insect(25).PNG": 408,
	"./levelS/insect/insect(26).PNG": 409,
	"./levelS/insect/insect(27).PNG": 410,
	"./levelS/insect/insect(28).PNG": 411,
	"./levelS/insect/insect(29).PNG": 412,
	"./levelS/insect/insect(3).PNG": 413,
	"./levelS/insect/insect(30).PNG": 414,
	"./levelS/insect/insect(31).PNG": 415,
	"./levelS/insect/insect(32).PNG": 416,
	"./levelS/insect/insect(33).PNG": 417,
	"./levelS/insect/insect(34).PNG": 418,
	"./levelS/insect/insect(35).PNG": 419,
	"./levelS/insect/insect(36).PNG": 420,
	"./levelS/insect/insect(37).PNG": 421,
	"./levelS/insect/insect(38).PNG": 422,
	"./levelS/insect/insect(39).PNG": 423,
	"./levelS/insect/insect(4).PNG": 424,
	"./levelS/insect/insect(40).PNG": 425,
	"./levelS/insect/insect(41).PNG": 426,
	"./levelS/insect/insect(5).PNG": 427,
	"./levelS/insect/insect(6).PNG": 428,
	"./levelS/insect/insect(7).PNG": 429,
	"./levelS/insect/insect(8).PNG": 430,
	"./levelS/insect/insect(9).PNG": 431,
	"./levelS/patrol/patrol(1).PNG": 97,
	"./levelS/patrol/patrol(10).PNG": 432,
	"./levelS/patrol/patrol(11).PNG": 433,
	"./levelS/patrol/patrol(12).PNG": 434,
	"./levelS/patrol/patrol(13).PNG": 435,
	"./levelS/patrol/patrol(14).PNG": 436,
	"./levelS/patrol/patrol(15).PNG": 437,
	"./levelS/patrol/patrol(16).PNG": 438,
	"./levelS/patrol/patrol(17).PNG": 439,
	"./levelS/patrol/patrol(18).PNG": 440,
	"./levelS/patrol/patrol(19).PNG": 441,
	"./levelS/patrol/patrol(2).PNG": 442,
	"./levelS/patrol/patrol(20).PNG": 443,
	"./levelS/patrol/patrol(21).PNG": 444,
	"./levelS/patrol/patrol(22).PNG": 445,
	"./levelS/patrol/patrol(23).PNG": 446,
	"./levelS/patrol/patrol(24).PNG": 447,
	"./levelS/patrol/patrol(25).PNG": 448,
	"./levelS/patrol/patrol(26).PNG": 449,
	"./levelS/patrol/patrol(27).PNG": 450,
	"./levelS/patrol/patrol(28).PNG": 451,
	"./levelS/patrol/patrol(29).PNG": 452,
	"./levelS/patrol/patrol(3).PNG": 453,
	"./levelS/patrol/patrol(30).PNG": 454,
	"./levelS/patrol/patrol(31).PNG": 455,
	"./levelS/patrol/patrol(32).PNG": 456,
	"./levelS/patrol/patrol(33).PNG": 457,
	"./levelS/patrol/patrol(34).PNG": 458,
	"./levelS/patrol/patrol(4).PNG": 459,
	"./levelS/patrol/patrol(5).PNG": 460,
	"./levelS/patrol/patrol(6).PNG": 461,
	"./levelS/patrol/patrol(7).PNG": 462,
	"./levelS/patrol/patrol(8).PNG": 463,
	"./levelS/patrol/patrol(9).PNG": 464,
	"./levelS/plane/plane(1).PNG": 98,
	"./levelS/plane/plane(10).PNG": 465,
	"./levelS/plane/plane(11).PNG": 466,
	"./levelS/plane/plane(12).PNG": 467,
	"./levelS/plane/plane(13).PNG": 468,
	"./levelS/plane/plane(14).PNG": 469,
	"./levelS/plane/plane(15).PNG": 470,
	"./levelS/plane/plane(16).PNG": 471,
	"./levelS/plane/plane(17).PNG": 472,
	"./levelS/plane/plane(18).PNG": 473,
	"./levelS/plane/plane(19).PNG": 474,
	"./levelS/plane/plane(2).PNG": 475,
	"./levelS/plane/plane(20).PNG": 476,
	"./levelS/plane/plane(21).PNG": 477,
	"./levelS/plane/plane(22).PNG": 478,
	"./levelS/plane/plane(23).PNG": 479,
	"./levelS/plane/plane(24).PNG": 480,
	"./levelS/plane/plane(25).PNG": 481,
	"./levelS/plane/plane(26).PNG": 482,
	"./levelS/plane/plane(27).PNG": 483,
	"./levelS/plane/plane(28).PNG": 484,
	"./levelS/plane/plane(3).PNG": 485,
	"./levelS/plane/plane(4).PNG": 486,
	"./levelS/plane/plane(5).PNG": 487,
	"./levelS/plane/plane(6).PNG": 488,
	"./levelS/plane/plane(7).PNG": 489,
	"./levelS/plane/plane(8).PNG": 490,
	"./levelS/plane/plane(9).PNG": 491,
	"./map.jpg": 650,
	"./mine.TTF": 651,
	"./newMap.jpg": 130,
	"./news/CNews1.png": 54,
	"./news/CNews2.png": 131,
	"./news/CNews3.png": 132,
	"./news/CNews4.png": 133,
	"./news/CNews5.png": 134,
	"./news/CNews6.png": 135,
	"./news/CNews7.png": 136,
	"./news/CNews8.png": 137,
	"./news/companynewsImg1.jpg": 652,
	"./news/companynewsImg2.jpg": 653,
	"./news/companynewsImg3.jpg": 654,
	"./news/companynewsImg4.jpg": 655,
	"./news/companynewsImg5.jpg": 656,
	"./news/companynewsImg6.jpg": 657,
	"./news/companynewsImg7.jpg": 658,
	"./news/companynewsImg8.jpg": 659,
	"./news_1.jpg": 492,
	"./news_head_bg.jpg": 138,
	"./news_head_bg_2.jpg": 139,
	"./news_head_bg_3.jpg": 140,
	"./organizationBG.png": 101,
	"./partTBG.jpg": 165,
	"./posterS1-1.png": 493,
	"./production1.jpg": 660,
	"./production2.jpg": 661,
	"./production3.jpg": 662,
	"./production4.jpg": 663,
	"./schoolBG.png": 102,
	"./silderItem4.JPG": 664,
	"./slide1.jpg": 665,
	"./sliderItem1.JPG": 166,
	"./sliderItem10.JPG": 666,
	"./sliderItem2.JPG": 167,
	"./sliderItem3.JPG": 168,
	"./sliderItem5.JPG": 667,
	"./sliderItem6.JPG": 668,
	"./sliderItem7.JPG": 669,
	"./sliderItem8.JPG": 670,
	"./sliderItem9.JPG": 671,
	"./starProduct1.png": 104,
	"./starProduct2.png": 105,
	"./starProduct3.png": 106,
	"./starProduct4.png": 107,
	"./starProduct5.png": 108,
	"./starProduct6.png": 109,
	"./starProduct7.png": 110,
	"./starProduct8.png": 111,
	"./steamBox.png": 141,
	"./t11.jpg": 672,
	"./t12.jpg": 673,
	"./t13.jpg": 674,
	"./t21.jpg": 675,
	"./t22.jpg": 676,
	"./t23.jpg": 677,
	"./t31.jpg": 678,
	"./t32.jpg": 679,
	"./t33.jpg": 680,
	"./t41.jpg": 681,
	"./t42.jpg": 682,
	"./t43.jpg": 683,
	"./t51.jpg": 684,
	"./t52.jpg": 685,
	"./t53.jpg": 686,
	"./video/WL.mp4": 100,
	"./video/amusement.mp4": 494,
	"./video/cockroach.mp4": 495,
	"./video/combat.mp4": 496,
	"./video/crocodile.mp4": 497,
	"./video/dinosaur.mp4": 498,
	"./video/dodgem.mp4": 499,
	"./video/frog.mp4": 500,
	"./video/game.mp4": 501,
	"./video/patrol.mp4": 502,
	"./video/plane.mp4": 503,
	"./video/ppc.mp4": 687,
	"./video/titi.mp4": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;